import { Pipe, PipeTransform } from '@angular/core';
import { cleanStringForComparison } from '../core/utilities';

@Pipe({
    name: 'highlightKeyword',
    standalone: true,
})
export class HighlightKeywordPipe implements PipeTransform {

  constructor() {
  }

  transform(text: string, keyword: string): string {
    if (!keyword) {
      return text;
    }

    let indexMatchStart: number = cleanStringForComparison(text).search(cleanStringForComparison(keyword));
    if (indexMatchStart == -1) {
      // no keyword to highlight in text was found
      return text;
    }
    let indexMatchEnd: number = indexMatchStart + keyword.length;

    const preMatchingText = text.substring(0, indexMatchStart);
    const matchingText = '<mark>' + text.substring(indexMatchStart, indexMatchEnd) + '</mark>';
    const postMatchingText = text.substring(indexMatchEnd);
    return '<span class="whitespace-pre-wrap">' + preMatchingText + matchingText + postMatchingText + '</span>';
  }

}
